import { IRequestParamsDestination } from '../../interfaces/models/product-destination';
import Base from './base';

export default {
  getList: async (productId?: number): Promise<any> => (await Base()).get(`/users/product-destination?${productId ? `productID=${productId}` : ''}`),
  add: async (data: IRequestParamsDestination): Promise<any> => (await Base()).post('/users/product-destination', data),
  remove: async (destId: string): Promise<any> => (await Base()).delete(`/users/product-destination/${destId}`),
};
